import { Injectable, inject } from '@angular/core';

import { ConfigProviderService } from '../../config-provider/config-provider.service';
import { CookieService } from '../../shared/cookie.service';

@Injectable({
    providedIn: 'root',
})
export class CasinoStylesService {
    private readonly configProviderService = inject(ConfigProviderService);
    private readonly cookieService = inject(CookieService);

    getDropShadow(category: any): string {
        const global: any = this.configProviderService.provideGlobalConfig();
        const darkMode = this.cookieService.getFromCookie('dark-mode');
        let dropShadow: string;
        if (darkMode) {
            dropShadow = category?.sitecoreData?.attributes?.darkmodegametiledropshadow
                ? category?.sitecoreData?.attributes?.darkmodegametiledropshadow
                : global.lobbyConfigurations['darkModeGameTileDropShadow'];
        } else {
            dropShadow = category?.sitecoreData?.attributes?.gametiledropshadow
                ? category?.sitecoreData?.attributes?.gametiledropshadow
                : global.lobbyConfigurations['gameTileDropShadow'];
        }
        return dropShadow;
    }

    getBorderRadius(category: any): string {
        const global: any = this.configProviderService.provideGlobalConfig();
        const gameTileBorderRadius = category?.sitecoreData?.attributes?.gametileborderradius
            ? category?.sitecoreData?.attributes?.gametileborderradius
            : global.lobbyConfigurations['gameTileBorderRadius'];
        return !category.isIconSixCategory ? gameTileBorderRadius : null; //filtering out iconsix game icon
    }

    getLTileFontFamily(category: any): string {
        const global: any = this.configProviderService.provideGlobalConfig();
        const lobbyTileFontFamily = category?.sitecoreData?.attributes?.lobbytilefontfamily
            ? category?.sitecoreData?.attributes?.lobbytilefontfamily
            : global.lobbyConfigurations['lobbyTileFontFamily'];
        return lobbyTileFontFamily;
    }

    getsubCategoryTextColor(category: any): string {
        const global: any = this.configProviderService.provideGlobalConfig();
        const subCategoryTextColor = category?.sitecoreData?.attributes?.subcategorytextcolor
            ? category?.sitecoreData?.attributes?.subcategorytextcolor
            : global.lobbyConfigurations['subCategoryTextColor'];
        return subCategoryTextColor;
    }

    getsubCategoryTitleFontSize(category: any): string {
        const global: any = this.configProviderService.provideGlobalConfig();
        const subCategoryTitleFontSize = category?.sitecoreData?.attributes?.subcategorytitlefontsize
            ? category?.sitecoreData?.attributes?.subcategorytitlefontsize
            : global.messages['subCategoryTitleFontSize'];
        return subCategoryTitleFontSize;
    }

    getsubCategorySubTitleFontSize(category: any): string {
        const global: any = this.configProviderService.provideGlobalConfig();
        const subCategorySubTitleFontSize = category?.sitecoreData?.attributes?.subcategorysubtitlefontsize
            ? category?.sitecoreData?.attributes?.subcategorysubtitlefontsize
            : global.messages['subCategorySubTitleFontSize'];
        return subCategorySubTitleFontSize;
    }

    appendTheme(src: any, gameInfo: any) {
        const featuresConfig: any = this.configProviderService.provideFeaturesConfig();
        let appendTheme = '';
        if (featuresConfig?.gameIconTheming) {
            const { [gameInfo]: gameId } = featuresConfig.gameIconTheming;
            if (gameId) {
                for (const theme in gameId) {
                    if (gameId[theme]) {
                        appendTheme = theme;
                    }
                }
            }
        }
        if (appendTheme && src && src.indexOf(appendTheme) < 0) {
            const arr = src?.split('/');
            arr?.splice(arr.length - 1, 0, appendTheme);
            src = arr.join('/');
        }
        return src;
    }
}
